import styled from 'styled-components';

import FFWebTheme from 'ff/debrief/common/StyledComponentThemes';
import TextField, {
    TextFieldProps,
} from 'ff/debrief/common/components/TextField';

export type ForeFlightTextFieldProps = TextFieldProps;

export const ForeFlightTextField = styled(TextField)`
    label {
        color: #646468;
    }
    input {
        color: ${FFWebTheme.blue};
        font-weight: 600;
        &::placeholder {
            color: ${FFWebTheme.placeholderGray};
        }
    }
    textarea {
        color: ${FFWebTheme.blue};
        font-weight: 600;
        &::placeholder {
            color: ${FFWebTheme.placeholderGray};
        }
    }
`;
